<template>
  <div
    class="rounded-sm w-full bg-white p-4 pr-2 border-1px border-grey-field overflow-auto"
    :class="{ 'h-auto': open }">
    <div class="flex cursor-pointer" @click="acknowledgePrivacyCollection">
      <span class="w-full text-grey-3 paragraph-2">
        Please read our privacy collection statement
      </span>
      <ChevronDown
        class="self-center mr-4 size-3"
        :class="{
          'transform rotate-180': open,
        }" />
    </div>
    <div v-if="open" class="mt-4 py-3 bg-blue-5 rounded px-4 text-grey-1 collapsible__content">
      <span>
        Otivo Pty Ltd ABN 47 602 457 732 (Otivo, we, us, or our) is committed to protecting your
        privacy. We collect your personal information from you (or your partner) when you (or your
        partner) register on, and use our platform to create financial plans.
        <br />
        <br />
      </span>
      <span>
        We use the personal information we collect for the purpose of providing advice on your
        financial situation. We do not trade, rent or sell your information or disclose it to any
        third parties.<br /><br />
      </span>
      <span>
        Our Privacy Policy contains more information about how to access and correct the information
        we hold about you and how to make a privacy related complaint. You can read it by visiting
        our website
        <a href="/content/privacy" target="_blank"> Privacy Policy. </a>
      </span>
    </div>
  </div>
  <div class="flex flex-row gap-x-[10px] cursor-pointer mt-5" @click="agreeToConditions">
    <BaseCheckbox v-model:checked="agreed" name="terms-and-conditions" />
    <p class="paragraph-2 text-grey-1">
      I understand that the advice is provided by Otivo (Otivo Pty Ltd ABN 47 602 457 732 AFSL and
      Australian Credit Licence No. 485665) and is limited and does not cover all aspects of my
      circumstances. I agree to receive all communications electronically.
    </p>
  </div>
</template>

<script setup lang="ts">
import ChevronDown from '@/components/icons/ChevronDown.vue'
import BaseCheckbox from '@/components/Inputs/BaseCheckbox.vue'
import { ref } from 'vue'
import { useAccountCreationStore } from '@/store/pinia/AccountCreationStore.ts'
import OtivoButton from '@/components/OtivoButton.vue'
import api from '@/services/Api.ts'

const agreed = ref(false)
const open = ref(false)
const acknowledgedPrivacy = ref(false)
const consented = ref(false)
const agreeToConditions = () => {
  agreed.value = !agreed.value
  if (agreed.value) consented.value = agreed.value
}
const acknowledgePrivacyCollection = () => {
  open.value = !open.value
  if (open.value) acknowledgedPrivacy.value = true
}

defineExpose({
  consented,
  acknowledgedPrivacy,
})
</script>

<style scoped></style>
